// dom.js — utility functions for DOM and accessibility

// Shorthand selectors
export const $ = (selector, context = document) => context.querySelector(selector);
export const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];

// Class utilities
export const addClass = (el, className) => el && el.classList.add(className);
export const removeClass = (el, className) => el && el.classList.remove(className);
export const toggleClass = (el, className) => el && el.classList.toggle(className);
export const hasClass = (el, className) => el && el.classList.contains(className);

// Data attributes
export const getData = (el, key) => el?.getAttribute(`data-${key}`);
export const setData = (el, key, value) => el?.setAttribute(`data-${key}`, value);

// Viewport checker
export const isInViewport = (el, offset = 0) => {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  return rect.top <= (window.innerHeight || document.documentElement.clientHeight) - offset;
};

// Secure external links with target="_blank"
export const secureExternalLinks = () => {
  const links = document.querySelectorAll('a[target="_blank"]');

  links.forEach((link) => {
    const rel = link.getAttribute('rel') || '';

    if (!rel.includes('noopener')) {
      link.setAttribute('rel', `${rel} noopener`.trim());
    }

    if (!rel.includes('noreferrer')) {
      link.setAttribute('rel', `${link.getAttribute('rel')} noreferrer`.trim());
    }
  });
};
